<template>
  <div v-if="local_page_keys !== null" data-app class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div>
            <h2 class="text-center">{{ local_page_keys.page_title }}</h2>
          </div>
        </md-card-header>
        <md-card-content>
          <v-tabs
              v-model="tab"
              background-color="primary"
              dark
          >
            <v-tab
                v-for="group of functionsList"
                :key="group.tab"
            >
              {{ group.tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item
                v-for="group of functionsList"
                :key="group.tab">
              <v-card flat>
                <v-card-text>
                  <SalarySortedTable
                      :is_clickable_row=true
                      :local_page_keys="local_page_keys"
                      :headers="headers"
                      :sortedData="group.content"
                      @rowInfoShow="showEditionWindow($event)"
                  ></SalarySortedTable>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </md-card-content>
      </md-card>
    </div>
    <md-dialog
        class="tm-check-dialog"
        :md-active.sync="showInfoEditialog"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showInfoEditialog = false">
          <span class="material-icons">close</span>
        </a>
        <md-dialog-content>
          <p class="text-center"><strong>{{ local_page_keys.table_header_function_name }}:</strong> <span>{{ infoDialog.name }}</span></p>
          <p  class="text-center"><strong>{{ local_page_keys.table_header_function_icon }}:</strong> <img class="tm-img-icon" :src="infoDialog.icon" width="30" height="30" alt=""></p>
          <md-field :class="input_price_class">
            <label for="inputFunctionPrice">{{ local_page_keys.table_header_function_price }}</label>
            <md-input type="number"
                      v-model="priceOffunction"
                      step="0.1"
                      min="0.1"
                      ref="inputFunctionPrice"
                      name="inputFunctionPrice"
                      id="inputFunctionPrice"
                      @input="isValidPriceInput = true"
            >
            </md-input>
          </md-field>
          <md-button v-if="validatedPrice" class="md-success" @click="updateFunctionPrice">{{ local_page_keys.label_button_save_changes }}</md-button>

        </md-dialog-content>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import SalarySortedTable from "../Components/SalarySortedTable.vue";
import filterfortable from '../../../filters/filterfortable';
export default {
  name: "FunctionsListEdit",
   components: {SalarySortedTable},
  data: () => ({
    tab: null,
    local_page_keys: null,
    functionsList: [],
    headers: [],
    count: 0,
    showInfoEditialog: false,
    infoDialog: {},
    priceOffunction: '',
    priceOfBefore: '',
    isValidPriceInput: true

  }),
  methods: {
    async getFunctionsList() {
      this.functionsList = [];
      this.count = 0;
      await this.$store.dispatch('functionsEdit/functionsList');
      let data = this.$store.getters['functionsEdit/functionsList'];
      if (Object.keys(data).includes('list')) {
        this.getGroupedFunctions(data.list)
      }
    },
    getHeaders() {
      this.headers = [
        {
          text: this.local_page_keys.table_header_function_name,
          value: 'name',
        },
        {
          text: this.local_page_keys.table_header_function_icon,
          value: 'icon',
        },
        {
          text: this.local_page_keys.table_header_function_price,
          value: 'price',
        }
      ]
    },
    getGroupedFunctions(list) {
      this.count++;
      let faceGroup = [
        'lip', 'face', 'teeth', 'freckles', 'lens_flar', 'cheekbones', 'ears', 'eye',
        'glasses', 'beard', 'nose', 'forehead', 'eyebrow', 'earings', 'neck',
        'facial_asymmetry', 'tongue', 'smile','chin', 'bald_spot', 'wrinkles', 'choker',
        'pimples'
      ];
      let bodyGroup = ['body', 'shoulders', 'chest', 'arms', 'bikini', 'biceps','breast', 'leg', 'waist', 'foot',
        'clothes', 'nail', 'muscle', 'clavicle', 'hip', 'slouch', 'tatoo'];
      let backgroundGroup = ['background', 'order_change_color'];
      let removeGroup = ['remove', 'delete'];
      let faceGroupedFunctions = [];
      let bodyGroupedFunctions = [];
      let backgroundGroupedFunctions = [];
      let removeGroupedFunctions = [];

      for (let func of list) {
        func.price = filterfortable('price', func.price)
        if (faceGroup.filter(el=>func.name.includes(el)).length > 0) {
          faceGroupedFunctions.push(func);
          list.splice(list.indexOf(func), 1);
        } else if (bodyGroup.filter(el=>func.name.includes(el)).length > 0) {
          bodyGroupedFunctions.push(func);
          list.splice(list.indexOf(func), 1);
        } else if (backgroundGroup.filter(el=>func.name.includes(el)).length > 0) {
          backgroundGroupedFunctions.push(func);
          list.splice(list.indexOf(func), 1);
        } else if (removeGroup.filter(el=>func.name.includes(el)).length > 0) {
          removeGroupedFunctions.push(func);
          list.splice(list.indexOf(func), 1);
        }
      }
      if (faceGroupedFunctions.length > 0 && !this.checkTab(this.local_page_keys.tab_face_functions)) {
        let tab = this.local_page_keys.tab_face_functions;
        this.functionsList.push({tab, content:faceGroupedFunctions})
      } else if (faceGroupedFunctions.length > 0 && this.checkTab(this.local_page_keys.tab_face_functions)) {
        this.plusArrayTotab(this.local_page_keys.tab_face_functions, faceGroupedFunctions)
      }
      if (bodyGroupedFunctions.length > 0 && !this.checkTab(this.local_page_keys.tab_body_functions)) {
        let tab = this.local_page_keys.tab_body_functions;
        this.functionsList.push({tab, content:bodyGroupedFunctions})
      } else if (bodyGroupedFunctions.length > 0 && this.checkTab(this.local_page_keys.tab_body_functions)) {
        this.plusArrayTotab(this.local_page_keys.tab_body_functions, bodyGroupedFunctions)
      }
      if (backgroundGroupedFunctions.length > 0 && !this.checkTab(this.local_page_keys.tab_background_functions)) {
        let tab = this.local_page_keys.tab_background_functions;
        this.functionsList.push({tab, content:backgroundGroupedFunctions})
      } else if (backgroundGroupedFunctions.length > 0 && this.checkTab(this.local_page_keys.tab_background_functions)) {
        this.plusArrayTotab(this.local_page_keys.tab_background_functions, backgroundGroupedFunctions)
      }
      if (removeGroupedFunctions.length > 0 && !this.checkTab(this.local_page_keys.tab_remove_functions)) {
        let tab = this.local_page_keys.tab_remove_functions;
        this.functionsList.push({tab, content:removeGroupedFunctions})
      } else if (removeGroupedFunctions.length > 0 && this.checkTab(this.local_page_keys.tab_remove_functions)) {
        this.plusArrayTotab(this.local_page_keys.tab_remove_functions, removeGroupedFunctions)
      }
      if (this.count < 3) {
       return this.getGroupedFunctions(list);
      }
      if (this.count === 3 && list.length > 0 && !this.checkTab(this.local_page_keys.tab_other_functions)) {
        let tab = this.local_page_keys.tab_other_functions;
        this.functionsList.push({tab, content:list})
      } else if (this.count === 3 && list.length > 0 && this.checkTab(this.local_page_keys.tab_other_functions)) {
        this.plusArrayTotab(this.local_page_keys.tab_other_functions, list)
      }
    },
    checkTab(tab) {
      let tabexists = false;
      if (this.functionsList.length > 0) {
        for (let item of this.functionsList) {
          tabexists = item.tab === tab;
          if (tabexists) break;
        }
      }
      return tabexists;
    },
    plusArrayTotab(tab, arrayData) {
      for (let item of this.functionsList) {
        if (item.tab === tab) {
          for (let func of arrayData) {
            item.content.push(func);
          }
        }
      }
    },
    showEditionWindow(event) {
      event.icon = filterfortable('icon', event.icon)
      this.priceOfBefore = Number (event.price).toFixed(2)
      this.priceOffunction = Number (event.price).toFixed(2)

      this.infoDialog = event;
      this.showInfoEditialog = true;
    },
    async updateFunctionPrice() {
      if (this.isValidPriceInput) {
        if (confirm(this.local_page_keys.confirm_save_changes)) {
          let formData = new FormData();
          formData.append('id', this.infoDialog.id);
          formData.append('price', Number (this.priceOffunction).toFixed(2));
          await this.$store.dispatch('functionsEdit/updatedFunction', formData);
          let data = await this.$store.getters['functionsEdit/updatedFunction'];
          if (Object.keys(data).includes('Status') && data.Status === 'Ok') {
            this.showEditionWindow(data.function);
            await this.getFunctionsList();
          } else if (Object.keys(data).includes('error') && Object.keys(data.error).includes('price')) {
            this.isValidPriceInput = false;
            alert(data.error.price);
          } else {
            alert(this.local_page_keys.alert_something_wrong)
          }
        } else {
          this.showInfoEditialog = false;
          this.infoDialog = {};
        }

      } else {
        this.isValidPriceInput = false;
        alert(this.local_page_keys.price_field_validation);

      }
    }

  },
  computed: {
    validatedPrice() {
      return Number (this.priceOfBefore).toFixed(2) !== Number (this.priceOffunction).toFixed(2) && Number (this.priceOffunction).toFixed(2) > 0;
    },
    input_price_class() {
      return this.isValidPriceInput ? '' : 'tm-val-error';
    },
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('functions_list_edit');
    await this.getFunctionsList();
    this.getHeaders();
  }
}
</script>

<style scoped>
/*Layout*/
@import '../../../assets/css/uikit/grid.css';
/*Utilities*/
@import '../../../assets/css/uikit/background.css';
@import '../../../assets/css/uikit/label.css';
@import '../../../assets/css/uikit/width.css';
@import '../../../assets/css/uikit/height.css';
@import '../../../assets/css/uikit/flex.css';
@import '../../../assets/css/uikit/margin.css';
@import '../../../assets/css/uikit/padding.css';
@import '../../../assets/css/uikit/position.css';
@import '../../../assets/css/uikit/utility.css';
@import '../../../assets/css/uikit/transition.css';
@import '../../../assets/css/uikit/text.css';
@import '../../../assets/css/uikit/overlay.css';
@import '../../../assets/css/uikit/animation.css';
@import '../../../assets/css/custom.css';
.tm-val-error {
  border: 2px solid red;
  padding-bottom: 0;
}
</style>